import styled from 'styled-components';

const InputField = styled.input`
  width: ${({ width }) => width || '100%'};
  max-width: ${({ maxWidth }) => maxWidth || '100%'};
  padding: 0 0 0 10px;

  && {
    border-radius: 5px;
    height: 44px;
    text-align: left;
    left: 5px;
    outline: none;
    border: ${({ hasError }) => (hasError ? '1px solid #B94A48' : '1px solid #999999')};
    &:focus {
      border: ${({ hasError }) => (hasError ? '1px solid #B94A48' : '1px solid #999999')};
    }
  }
`;

export default InputField;
